import { transports, format } from "winston";
import colorizer from "../colorizer";

export const create = () =>
	new transports.Console({
		format: format.combine(
			format.timestamp(),
			format.printf((info) => colorizer(info.level, `[${info.timestamp}] [${info.level}]: ${info.message}`))
		),
	});
